module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('multiselect', {
    attrs: {
      "placeholder": "Add a new product",
      "track-by": "label",
      "label": "label",
      "options": _vm.options,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_vm._l((_vm.chosenProducts), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "list-group-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.quantity),
        expression: "product.quantity"
      }],
      staticClass: "form-control pull-right quantity",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (product.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(product, "quantity", $event.target.value)
        }
      }
    }), _vm._v("\n\n                " + _vm._s(product.title)), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    DKK " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(product.price, 2))) + "\n                ")])])
  }), _vm._v(" "), (Object.keys(_vm.chosenProducts).length === 0) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                No products\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Save")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13bb225d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Products.vue
// module id = 382
// module chunks = 1